import { NgModule } from '@angular/core';
import { ThemeComponent } from './theme.component';
import { ThemeBlankComponent } from './theme-blank.component';

import { Routes, RouterModule } from '@angular/router';

// import {routers as mainErpRouters} from '../../routers/theme-erp/main'


const routes: Routes = [
    {
        "path": "",
        "component": ThemeComponent,
        "children": [
            {
                "path": "index",
                "loadChildren": "./pages/homepage/homepage.module#HomePageModule"
            },
            {
                "path": "location",
                "loadChildren": "./pages/location/location.module#LocationPageModule"
            },
            // About
            {
                "path": "about/ourstory",
                "loadChildren": "./pages/about/our-story/our-story.module#AboutOurStoryPageModule"
            },
            {
                "path": "about/ourteam",
                "loadChildren": "./pages/about/our-team/our-team.module#AboutOurTeamPageModule"
            },
            {
                "path": "about/gallery",
                "loadChildren": "./pages/about/gallery/gallery.module#AboutGalleryPageModule"
            },
            {
                "path": "news",
                "loadChildren": "./pages/news/news.module#NewsPageModule"
            },
            {
                "path": "service",
                "loadChildren": "./pages/service/service.module#ServicePageModule"
            },
            {
                "path": "promotion",
                "loadChildren": "./pages/promotion/promotion.module#PromotionPageModule"
            },
            {
                "path": "testimonials",
                "loadChildren": "./pages/testimonial/testimonial.module#TestimonialPageModule"
            },
            {
                "path": "blog",
                "loadChildren": "./pages/blog/blog.module#BlogPageModule"
            },


            // ...mainErpRouters,
            // ...organizationErpRouters,

            {
                "path": "",
                "redirectTo": "index",
                "pathMatch": "full"
            },
            {
                "path": "***",
                "redirectTo": "index",
                "pathMatch": "full"
            }
        ]
    },
    {
        "path": "",
        "component": ThemeBlankComponent,
        "children": [
            // ...posBlankRouters,
            // ...timerecordBlankRouters
        ]
    },
    {
        // "path": "**",
        // "redirectTo": "404",
        // "pathMatch": "full",

        "path": "**",
        "redirectTo": "index",
        "pathMatch": "full",
        // "loadChildren": "./pages/homepage/homepage.module#HomePageModule"
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ThemeRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/theme/theme-routing.module.ts